import axios from "axios";
import { Redirect } from "react-router-dom";
export function PostData(type, userData) {
  let BaseURL = process.env.REACT_APP_API;

  return new Promise((resolve, reject) => {
    fetch(BaseURL, {
      method: type,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json; charset=utf-8",
        method: type,
      },
      body: JSON.stringify(userData),
    })
      .then((response) =>
        response.json().then((res) => {
          if (res.Respuesta == 3) {
            localStorage.clear();
            window.location.href = "/";
          }
          resolve(res);
        })
      )
      .catch((error) => {
        reject(error);
        //console.log(error);
      });
  });

  return new Promise((resolve, reject) => {
    // With all properties
    let body = {
      userId: 1111,
      title: "This is POST request with body",
      completed: true,
    };
    axios
      .post("https://jsonplaceholder.typicode.com/todos", body)
      .then(function (response) {
        console.log(response.data);
        resolve(response);
      })
      .catch(function (error) {
        console.log(error);
        reject(error);
      });
  });
}
